import React from "react";
import PropTypes from "prop-types";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { colors } from "../config/colors";
import { styled } from "@mui/material/styles";
import "./index.css";

const CustomCheckStyled = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    ...theme.typography.subtitle2,
  },
}));

const ActiveCheckbox = styled(Checkbox)(() => ({
  color: colors.border,
  "& .Mui-checked": {
    color: colors.primary,
  },
}));

export const CustomCheckbox = ({
  label = "",
  isChecked = false,
  disabled = false,
  onChange = null,
}) => {
  return (
    <CustomCheckStyled
      className="checkboxLabel"
      value={label}
      control={disabled ? <Checkbox /> : <ActiveCheckbox />}
      label={label}
      checked={isChecked}
      disabled={disabled}
      onChange={disabled ? null : onChange} // Changed onClick to onChange for better accessibility
      labelPlacement="end"
    />
  );
};

CustomCheckbox.propTypes = {
  label: PropTypes.string,
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};